import request from '@/utils/request'
import { Message } from 'element-ui'

// 老的匹配接口
// 获取医药公司列表
export function getList() {
  return request({
    url: '/shop/shop/yygs/list',
    method: 'get'
  })
}

// 获取可执行任务
export function getmatchTask(data) {
  return request({
    url: '/drug/matchTask/get',
    method: 'get',
    params: data
  })
}

// 执行数据导入
export function productDataImport(data) {
  return request({
    url: `/drug/matchData/productDataImport?taskId=${data}`,
    method: 'post'
  })
}
// 匹配数据确认
export function MatchDataConfirm(data) {
  return request({
    url: '/drug/matchData/matchDataConfirm',
    method: 'put',
    data
  })
}

// 执行匹配
export function runMatch(data) {
  return request({
    url: '/drug/matchTask/runMatch',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    params: data
  })
}

// 匹配数据分页
export function matchDataPage(data) {
  return request({
    url: '/drug/matchData/matchDataPage',
    method: 'get',
    params: data
  })
}

// 不匹配数据分页
export function unMatchDataPage(data) {
  return request({
    url: '/drug/matchTask/unMatchDataPage',
    method: 'get',
    params: data
  })
}

// 新增导入任务
export function fileImport(data) {
  return request({
    url: '/drug/matchTask/fileImport',
    method: 'post',
    data
  })
}

// 失败数据导出
export function fileExport(data) {
  return request({
    url: '/drug/matchTask/fileExport',
    method: 'get',
    responseType: 'blob',
    params: data
  }).then(response => {
    // 处理返回的文件流
    const blob = response
    if (blob && blob.size === 0) {
      Message.warning('内容为空，无法下载')
      return
    }
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    // link.download = fileName;
    document.body.appendChild(link)
    link.click()
    window.setTimeout(function() {
      URL.revokeObjectURL(blob)
      document.body.removeChild(link)
    }, 0)
  })
}

// 文件导入模板下载
export function fileTemplate() {
  return request({
    url: '/drug/goods/goodsSkuImportRecords/templateUrl',
    method: 'get',
  })
}

// 目标匹配数据查询
export function targetDataPage(data) {
  return request({
    url: `/drug/matchData/targetDataPage?nationalCode=${data}`,
    method: 'get'
  })
}


// 新的匹配接口
// 目标匹配数据查询
export function goodsSkuSyncCaches(data) {
  return request({
    url: `/drug/goods/goodsSkuSyncCaches/listWithGoodInfoV2`,
    method: 'get',
    params: data
  })
}


// 列表
export function goodsBases(data) {
  return request({
    url: `/drug/goods/goodsBases`,
    method: 'get',
    params: data
  })
}

// 关联商品
export function associations(id,data) {
  return request({
    url: `/drug/goods/goodsSkuSyncCaches/${id}/associations`,
    method: 'post',
    data
  })
}

//部分修改 
export function goodsSkuSyncCachesPackUnit(id,data) {
  return request({
    url: `/drug/goods/goodsSkuSyncCaches/${id}`,
    method: 'PATCH',
    data
  })
}
//
export function goodsSkuMatchTasks(data) {
  return request({
    url: `/drug/goods/goodsSkuMatchTasks`,
    method: 'post',
    data
  })
}
// 数量
export function quantity(data) {
  return request({
    url: `/drug/goods/goodsSkuSyncCaches/quantity`,
    method: 'get',
    params:data
  })
}
// 批量删除
export function deleteRecords(data) {
  return request({
    url: `/drug/goods/goodsSkuSyncCaches/deleteRecords`,
    method: 'post',
    data
  })
}
// 批量删除
export function undoDeleteRecords(data) {
  return request({
    url: `/drug/goods/goodsSkuSyncCaches/undoDeleteRecords`,
    method: 'post',
    data
  })
}

// 头部数量
export function goodsSkuSyncCacheStatistics(data) {
  return request({
    url: `/drug/goods/goodsSkuSyncCacheStatistics/matchResultTypes`,
    method: 'get',
    params:data
  })
}
// 批量上架
export function goodsSkuSyncCachesPublish(data) {
  return request({
    url: `/drug/goods/goodsSkuSyncCaches/publish`,
    method: 'POST',
    data
  })
}
// 全部上架
export function allPublish(data) {
  return request({
    url: `/drug/goods/goodsSkuSyncCaches/allPublish`,
    method: 'POST',
    data
  })
}

// 取消匹配
export function cancelAssociation(data) {
  return request({
    url: `/drug/goods/goodsSkuSyncCaches/${data.id}/cancelAssociation`,
    method: 'POST',
    data
  })
}

// 匹配状态统计列表
export function goodsSkuSyncCacheStatisticsStates(data) {
  return request({
    url: `/drug/goods/goodsSkuSyncCacheStatistics/statesV2`,
    method: 'get',
    params:data
  })
}

// 批量匹配 
export function batchAssociations(data) {
  return request({
    url: `/drug/goods/goodsSkuSyncCaches/batchAssociations`,
    method: 'POST',
    data
  })
}
